(function () {
  const ROW_PATTERN = [2];

  function scheduleActive(item, nowSec) {
    if (item.dataset.scheduleEnabled !== 'true') return true;

    const start = parseInt(item.dataset.scheduleStart || '0', 10);
    const end = parseInt(item.dataset.scheduleEnd || '0', 10);

    if (start > 0 && nowSec < start) return false;
    if (end > 0 && nowSec >= end) return false;
    return true;
  }

  function applyScheduleVisibility(root) {
    const designMode = root.dataset.designMode === 'true';
    const nowSec = Math.floor(Date.now() / 1000);

    root.querySelectorAll('[data-kampanyalar-item]').forEach((item) => {
      const active = scheduleActive(item, nowSec);

      item.classList.remove('hp-kampanyalar__item--schedule-off');
      item.classList.remove('hp-kampanyalar__item--scheduled-hidden');

      if (active) {
        item.removeAttribute('hidden');
        return;
      }

      if (designMode) {
        item.classList.add('hp-kampanyalar__item--scheduled-hidden');
        item.removeAttribute('hidden');
      } else {
        item.classList.add('hp-kampanyalar__item--schedule-off');
        item.setAttribute('hidden', '');
      }
    });
  }

  function getVisibleItems(root) {
    return [...root.querySelectorAll('[data-kampanyalar-item]')].filter((item) => {
      if (item.hasAttribute('hidden')) return false;
      if (item.classList.contains('hp-kampanyalar__item--schedule-off')) return false;
      return !item.classList.contains('is-filter-hidden');
    });
  }

  function matchesFilter(item, filter) {
    const audience = item.dataset.petAudience || 'both';
    if (filter === 'all') return true;
    if (filter === 'cat') return audience === 'cat' || audience === 'both';
    if (filter === 'dog') return audience === 'dog' || audience === 'both';
    return true;
  }

  function layoutRows(root) {
    const rowsHost = root.querySelector('[data-kampanyalar-rows]');
    const stash = root.querySelector('[data-kampanyalar-stash]');
    if (!rowsHost || !stash) return;

    const allItems = [...root.querySelectorAll('[data-kampanyalar-item]')];
    allItems.forEach((item) => stash.appendChild(item));

    const items = getVisibleItems(root);
    rowsHost.replaceChildren();

    if (items.length === 0) {
      const empty = root.querySelector('[data-kampanyalar-empty]');
      if (empty) empty.hidden = false;
      return;
    }

    const empty = root.querySelector('[data-kampanyalar-empty]');
    if (empty) empty.hidden = true;

    let patternIndex = 0;
    let offset = 0;

    while (offset < items.length) {
      const targetCols = ROW_PATTERN[patternIndex % ROW_PATTERN.length];
      const remaining = items.length - offset;
      const take = Math.min(targetCols, remaining);
      // Son satırda tek kart kalsa bile masaüstünde 2 kolon kalsın (sağ boş).
      const layoutCols = targetCols;
      const row = document.createElement('div');
      row.className = `hp-kampanyalar__row hp-kampanyalar__row--${layoutCols}`;
      row.style.setProperty('--hp-kamp-row-cols', String(layoutCols));

      const chunk = items.slice(offset, offset + take);
      chunk.forEach((item) => row.appendChild(item));
      rowsHost.appendChild(row);

      offset += take;
      patternIndex += 1;
    }
  }

  function applyFilter(root, filter) {
    root.querySelectorAll('[data-kampanyalar-item]').forEach((item) => {
      const visible = matchesFilter(item, filter);
      item.classList.toggle('is-filter-hidden', !visible);
    });
    layoutRows(root);
  }

  function initRoot(root) {
    if (root.dataset.kampanyalarInit === 'true') return;
    root.dataset.kampanyalarInit = 'true';

    const filterButtons = [...root.querySelectorAll('[data-kampanyalar-filter]')];

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.kampanyalarFilter || 'all';
        filterButtons.forEach((btn) => {
          const isActive = btn === button;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyFilter(root, filter);
      });
    });

    applyScheduleVisibility(root);
    layoutRows(root);

    window.setInterval(() => {
      applyScheduleVisibility(root);
      layoutRows(root);
    }, 60000);
  }

  function initAll() {
    document.querySelectorAll('[data-hp-kampanyalar]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-hp-kampanyalar]');
    if (root) {
      delete root.dataset.kampanyalarInit;
      initRoot(root);
    }
  });
})();
